export default __webpack_public_path__ + "static/media/product-liquid.cdb6a860.svg";